import styled from '@emotion/styled';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  companyCodesFilterCountryIdSelector,
  companyCodesCompanyCodesLoadingSelector,
  companyCodesFindRequested,
} from '../../state';
import { LoadingButton } from '../buttons';
import { CompanyCodesFilters } from './CompanyCodesFilters';

const ActionContainer = styled.div`
  display: flex;
  width: max-content;
  margin-left: auto;
  justify-content: right;

  > button:first-of-type {
    margin-right: ${props => props.theme.spacing(2)};
  }

  ${props => props.theme.breakpoints.down('md')} {
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
  }
`;

const ButtonApply = () => {
  const dispatch = useDispatch();
  const handleClickApply = useCallback(() => dispatch(companyCodesFindRequested()), [dispatch]);
  const { t } = useTranslation();
  const loading = useSelector(companyCodesCompanyCodesLoadingSelector);
  const hasCountry = Boolean(useSelector(companyCodesFilterCountryIdSelector));
  const applyDisabled = !hasCountry;
  return (
    <LoadingButton
      color="primary"
      variant="contained"
      onClick={handleClickApply}
      loading={loading}
      disabled={applyDisabled}
    >
      {t('navigation.buttons.apply')}
    </LoadingButton>
  );
};

const CompanyCodesSearch = () => {
  const hasCountry = Boolean(useSelector(companyCodesFilterCountryIdSelector));
  const applyDisabled = !hasCountry;
  const countryRequiredIncomplete = applyDisabled;

  const actions = (
    <ActionContainer data-tour="process-actions">
      <ButtonApply />
    </ActionContainer>
  );
  return (
    <CompanyCodesFilters
      actions={actions}
      applyDisabled={applyDisabled}
      countryRequiredIncomplete={countryRequiredIncomplete}
    />
  );
};

export default CompanyCodesSearch;
